export const launchDarklyLogger = {
    debug: () => { }, // No-op for debug
    info: () => { }, // No-op for info
    warn: () => { }, // No-op for warn
    error: (message) => {
        console.error(message); // Only log errors
    }
};
